export default "__VITE_ASSET__Dwz9eZmY__"